import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HomePropFirms from './components/HomePropFirms';
import HomeStrategies from './components/HomeStrategies';
import HomeArticles from './components/HomeArticles';
import SeoHead from '@/components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.diariode1trader.com';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: `${siteUrl}/`,
      name: 'Diário de 1 Trader',
      description: 'Guia completo de prop firms, estratégias de trading de futuros e artigos educacionais para traders portugueses.',
      inLanguage: 'pt-PT',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/artigos?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'Diário de 1 Trader',
      url: `${siteUrl}/`,
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'info@diariode1trader.com',
        contactType: 'customer support',
        availableLanguage: 'Portuguese',
      },
      sameAs: ['https://www.youtube.com/@diario1trader'],
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: `${siteUrl}/`,
      name: 'Diário de 1 Trader | Trading de Futuros, Prop Firms e Estratégias',
      description: 'Guia completo de prop firms, estratégias de trading de futuros e artigos educacionais para traders portugueses.',
      inLanguage: 'pt-PT',
      isPartOf: { '@id': `${siteUrl}/#website` },
    },
  ],
};

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <SeoHead
        title="Diário de 1 Trader | Trading de Futuros, Prop Firms e Estratégias"
        description="Diário de 1 Trader: guia completo de prop firms, estratégias de trading de futuros e artigos educacionais para traders portugueses. Comparações, análises e conteúdo gratuito."
        keywords="prop firms, trading futuros, estratégias trading, diário trader, futuros portugal"
        canonical="/"
        schema={homeSchema}
      />
      <Navbar />
      <HeroSection />
      <HomePropFirms />
      <HomeStrategies />
      <HomeArticles />
      {/* Trust Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <p className="text-slate-400 text-sm font-semibold uppercase tracking-widest mb-8">Analisamos as melhores prop firms do mercado</p>
          <div className="flex flex-wrap items-center justify-center gap-10 opacity-60">
            {['FTMO', 'Topstep', 'Apex Trader Funding', 'The Funded Trader', 'E8 Markets'].map((name) => (
              <span key={name} className="text-slate-500 font-bold text-lg">{name}</span>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
